import { MailConversationDataType } from "@packages/chat-sdk";
import { Store } from "./store";
export interface MailChatStoreType {
  selectedConversation?: MailConversationDataType;
  // 机器人列表
  robotOptions?: { label: string; value: string }[];
}

export const mailChatStore = new Store<MailChatStoreType>(() => ({
  selectedConversation: undefined,
  robotOptions: [],
  roomQRCodesMap: {},
}));
export const mailChatStoreActions = {
  setSelectedConversation(payload?: MailConversationDataType) {
    mailChatStore.set({
      selectedConversation: payload,
    });
  },
  setRobotOptions(payload: { label: string; value: string }[]) {
    mailChatStore.set({
      robotOptions: payload,
    });
  },
};
